export const LEGEND_STYLE: Readonly<Record<string, string>> = {
  oneWay: '#6FEAD4',
  roundTrip: '#1B957F',
};

export const RangeMapLegend = () => {
  return (
    <div className="flex gap-2xl">
      <div className="flex items-center gap-s">
        <div
          className="size-[22px] rounded-full"
          style={{
            background: LEGEND_STYLE.oneWay,
          }}
        />
        <div className="text-body1Light text-black">One Way</div>
      </div>

      <div className="flex justify-center gap-2.5">
        <div
          className="size-[22px] rounded-full"
          style={{
            background: LEGEND_STYLE.roundTrip,
          }}
        />
        <div className="text-body1Light text-black">Round Trip</div>
      </div>
    </div>
  );
};
